import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Calendar = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '16',
    defaultHeight: '16',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 16 16'
    >
      <g clipPath='url(#clip0_19027_144196)'>
        <path
          d='M13 3H3C1.89543 3 1 3.89543 1 5V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V5C15 3.89543 14.1046 3 13 3Z'
          stroke={primaryColorToUse}
          strokeWidth='1.5'
        />
        <path d='M1 7H15' stroke={primaryColorToUse} strokeWidth='1.5' />
        <path
          d='M5 1V4M11 1V4'
          stroke={primaryColorToUse}
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_19027_144196'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
